export default __webpack_public_path__ + "static/media/large.151ba5bb.jpg";